<h2 mat-dialog-title>{{ 'Életkor ellenőrzése' | translate }}</h2>
<mat-dialog-content>
    <div>
        <p>{{ 'Kérjük, add meg a születési dátumodat!' | translate }}</p>
        <p>{{ 'Az oldalon található kutyás tartalmak és szolgáltatások önmagukban nem korhatárosak. A születési dátum
            megadására azért van szükségünk, mert ifjúságvédelmi előírások szerint csak 18. életévüket betöltött
            felhasználók használhatják. Az adatokat nem tároljuk.' | translate }}</p>
        <p>{{
            'A születési dátum kiválasztásához kattints a naptár ikonra.' | translate
            }}</p>
    </div>
    <form [formGroup]="agePickerForm">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
            <input matInput formControlName="birthday" [matDatepicker]="picker" [matDatepickerFilter]="futureFilter"
                readonly />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{ 'Mégse' | translate }}</button>
    <button mat-button color="primary" [mat-dialog-close]="isDate18orMoreYearsOld(agePickerForm.value.birthday)">
        <span>{{ 'Életkor ellenőrzése' | translate }}</span>
    </button>
</mat-dialog-actions>